<template>
  <div class="autocomplete-results">
      <div 
        class="autocomplete-result" 
        v-for="(item,index) in results" 
        :key="index"
        @click="onSelect(item)">
          {{ item.name }} ({{item.price}} ₴)
      </div>
  </div>
</template>

<script>
export default {
    props: {
        value: String,
    },
    data() {
        return {
            selected: true,
        }
    },
    watch: {
        value() {
            this.selected = false;
        }
    },
    methods: {
        onSelect(item) {
            this.$emit('select', item);
            this.selected = true;
        }
    },
    computed: {
        results() {
            if (!this.value || this.selected) return [];

            const q = this.value.toLowerCase();

            const to_return = this.modificators.filter(mod => {
                return mod.name.toLowerCase().includes(q);
            });

            //there will be at least 1 result - the modificator
            //which we are editing, and we should not show it
            if (to_return.length <= 1) return [];

            return to_return;
        },
        modificators() {
            return this.$store.getters['menu/modificatorsList'];
        }
    }
}
</script>

<style scoped>
.autocomplete-results {
    width: 100%;
    position: absolute;
    top: 4.5vh;
    z-index: 10;
}

.autocomplete-result {
  width: 100%;
  color: #1d1d1b;
  background: #ededed;
  border-bottom: 1px solid #a4a4a4;
  cursor: pointer;
  padding: 0.3vh;
}

.autocomplete-result:hover {
  color: #ededed;
  background: #416293;
}
</style>